module.exports = __webpack_public_path__ + "static/media/hp-card-segui-paziente.da7b6353.jpg";